module.exports = __webpack_public_path__ + "img/systemlogo.5e4b1678.png";